import {z} from 'zod';

export const ServiceCaseTypeFormSchema = z.object({
  name: z.string().min(1),
  authorizationProfileId: z.string().min(1),
  docSeriesServiceCaseId: z.string().min(1),
  docSeriesServiceOrderId: z.string().min(1),
});

export type ServiceCaseTypeForm = z.infer<typeof ServiceCaseTypeFormSchema>;
